export const CONTENT_TYPES = {
  searchCustomer: "searchCustomer",
  newCustomer: "newCustomer",
  contractSelect: "contractSelect",
};

export const PREFERRED_COMMUNICATION_METHODS = ["Email", "SMS"];

export const HOW_DID_YOU_HEAR_ABOUT_US_OPTIONS = ["Email", "SMS", "Internet", "Other"];
